import '../App.css';
import '../assets/styles/header.css';
import React from 'react';
import { useNavigate } from "react-router-dom";

function ShowNav() {

  const navigate = useNavigate();

  const handleHomePage = () => {
    navigate("/");
  }

  const handleTopicPage = () => {
    navigate("/topics");
  }

  const handleListPage = () => {
    navigate("/glossary");
  }

  const handleRequestPage = () => {
    navigate("/request"); // Need to fix error where word isn't set yet
  }

  return (
    <div className='taskbar'>
        <a className="task-link" onClick={() => handleHomePage()}>Home</a>
        <a className="task-link" onClick={() => handleTopicPage()}>Browse By Topic</a>
        <a className="task-link" onClick={() => handleListPage()}>See Full Word List</a>
        <a className="task-link" onClick={() => handleRequestPage()}>Request A Word</a>
    </div>
  );
}
  
export default ShowNav;